import { useContext } from 'react'
import { Toast } from 'primereact/toast'
import { ToastContext } from '../contexts/ToastContext'

export const useToast = (): React.RefObject<Toast | null> => {
  const context = useContext(ToastContext)
  if (context === null) {
    throw new Error('useToast must be used within a ToastProvider')
  }
  return context
}
